import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import axiosInstance from "../../API/axiosConfig";
import webserviceUrl, { BASE_URL } from "../../API/webserviceUrl";
import { employee_id, school_code } from "../../utils/constant";
import useUserData from "../../custom_hooks/useUserData";
import { toast } from "react-toastify";
import Loading from "../loading/Loading";
import DeleteModal from "../../core/modals/deleteModal";
import { McitiImg } from "../../utils/iconLogo";
import LoadingGreen from "../loading/LoadingGreen";

type RenderUploadedFilesProps = {
  files: File[];
  type: "local" | "server";
  // onDelete: () => void;
};

const Submissionbatch = () => {
  const [firstTimeRender, setFirstTimeRender] = useState(1);
  // const [activeTab, setActiveTab] = useState("Attendance Sheet (Handwritten)");
  const [activeTab, setActiveTab] = useState("Student Data Sheet");
  const { course } = useUserData();
  const [uploadedFiles, setUploadedFiles] = useState<{ [key: string]: File[] }>(
    {},
  );
  const [formData, setFormData] = useState({
    school_code: school_code,
    employee_id: employee_id,
    level: course?.level,
  });
  const [trainerDocFiles, setTrainerDocFiles] = useState<any>([]);
  const [documentList, setDocumentList] = useState<any>([]);
  const [mergedPdfData, setMergedPdfData] = useState<any>("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState<number | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [youtubeLink, setYoutubeLink] = useState("");

  // documentTabContent?.youtube_link || "",

  function handleSaveYoutubeLink(url: string) {
    // replace with your real save call, e.g.:
    // updateDocumentTabContent({ youtube_link: url });
  }

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const [deleteTarget, setDeleteTarget] = useState<{
    type: "local" | "server";
    tab?: string;
    index?: number;
    form_upload_id?: string;
  } | null>(null);
  const [completedTabs, setCompletedTabs] = useState<{
    [key: string]: boolean;
  }>({});
  const documentTabContent: any = documentList?.find(
    (item: any) => item?.document_name === activeTab,
  );
  const isLastTab = documentTabContent?.seq === documentList?.length;
  const isNextDisabled = !(
    documentTabContent?.is_skip == 1 || documentTabContent?.info_saved == 1
  );
  const tabRefs = useRef<{ [key: string]: HTMLButtonElement | null }>({});
  const [isLoading, setIsLoading] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const [loading, setLoading] = useState(false);

  // Cohorts (batches) come from the get_batches API
  const [cohortOptions, setCohortOptions] = useState<any[]>([]);
  const [selectedCohort, setSelectedCohort] = useState<string>("");
  const [cohort, setcohort] = useState<any>({});
  const [cohortLoading, setCohortLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [uploading, setUploading] = useState(false);

  console.log(selectedFiles, "pressings");

  const handleUploadPhotos = async () => {
    try {
      setUploading(true);

      const token = localStorage.getItem("token");

      const formData: any = new FormData();

      formData.append("day", String(selectedDay));

      selectedFiles.forEach((file) => {
        formData.append("photos", file, file.name);
      });

      // IMPORTANT: inspect FormData this way
      for (const [key, value] of formData.entries()) {
        console.log(
          key,
          value instanceof File
            ? {
                name: value.name,
                type: value.type,
                size: value.size,
              }
            : value,
        );
      }

      const resp = await axiosInstance.post(
        `${BASE_URL}/photos/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // DON'T manually set Content-Type
          },
        },
      );

      console.log("Upload response:", resp.data);

      if (resp?.data?.success) {
        toast.success(resp?.data?.message || "Photos uploaded successfully!");

        setSelectedFiles([]);
      } else {
        toast.error(resp?.data?.message || "Failed to upload photos.");
      }
    } catch (error) {
      console.error("Photo upload failed:", error);
      toast.error("Failed to upload photos.");
    } finally {
      setUploading(false);
    }
  };
  // Adds newly chosen files to whatever's already queued, instead of
  // replacing them — so picking files twice accumulates a multi-image batch.
  const handleFilesSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(e.target.files || []);
    setSelectedFiles((prev) => [...prev, ...newFiles]);
    e.target.value = ""; // allows re-selecting the same file name later
  };

  const removeSelectedFile = (idx: number) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== idx));
  };

  // Resets the day selection whenever it changes, so a new day always
  // starts with an empty photo queue instead of carrying over the last
  // day's selections.
  useEffect(() => {
    setSelectedFiles([]);
  }, [selectedDay]);

  // const handleUploadPhotos = async () => {
  //   if (!selectedDay || selectedFiles.length === 0) return;
  //   try {
  //     setUploading(true);
  //     const formData = new FormData();
  //     formData.append("day", String(selectedDay));
  //     selectedFiles.forEach((file) => formData.append("photos", file));

  //     // await axios.post(webserviceUrl.uploadTrainingPhotos, formData, {
  //     //   headers: { "Content-Type": "multipart/form-data" },
  //     // });

  //     setSelectedFiles([]);
  //     // TODO: refresh the uploaded-photos list / show a success toast here
  //   } catch (error) {
  //     console.error("Photo upload failed:", error);
  //     // TODO: show an error toast here
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  // Fetch batches and use them as the cohort dropdown options
  const getCohorts = async () => {
    if (!school_code) return; // safety check
    try {
      setCohortLoading(true);
      const resp = await axiosInstance.post(webserviceUrl.get_batches, {
        employee_id,
        school_code,
      });

      const batchData = resp?.data?.data || [];
      setCohortOptions(batchData);
    } catch (error) {
      console.error("Error fetching cohorts:", error);
    } finally {
      setCohortLoading(false);
    }
  };

  useEffect(() => {
    getCohorts();
  }, [school_code]);

  useEffect(() => {
    if (course && Object.keys(course).length > 0) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        acdmc_course_id: course.acdmc_course_id ?? "",
      }));
    }
  }, [course]);
  useEffect(() => {
    const timer = setTimeout(() => setPageLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  // Load completed tabs from localStorage
  useEffect(() => {
    const savedCompletedTabs = JSON.parse(
      localStorage.getItem("completedTabs") || "{}",
    );
    setCompletedTabs(savedCompletedTabs);
  }, []);

  const getDocuments = async () => {
    try {
      // setIsLoading(true);
      const resp = await axiosInstance.post(
        webserviceUrl.get_student_documents,
        formData,
      );
      // console.log("submission data", resp);
      const unitData = resp?.data?.data || [];
      //@ts-ignore
      const [day, month, year] = formData?.date?.split("-") || [];
      // Add 'key' field to each item (React uses this)
      const processed = unitData.map((item: any, index: number) => ({
        ...item,
        key: index + 1, // Or use item.lesson_plan_id if it's guaranteed unique,
        day: day,
        month: month,
        year: year,
      }));
      setDocumentList(processed || []); // Uncomment & adjust based on actual API response
    } catch (error) {
      console.error("Error fetching attendance:", error);
    } finally {
      // setTimeout(() => setIsLoading(false), 1000);
    }
  };

  useEffect(() => {
    getDocuments();
  }, []);

  // console.log('firsttimerender', firstTimeRender);
  // console.log(documentList)

  // get documents
  const getTrainerDocs = async () => {
    try {
      setIsLoading(true);
      const resp = await axiosInstance.post(
        webserviceUrl.get_trainer_submission,
        {
          school_code: school_code || "",
          employee_id: employee_id || "",
          form_seq_id: documentTabContent?.form_seq_id || "",
        },
      );
      // // console.log("submission data", resp);
      const unitData = resp?.data?.data || [];
      //@ts-ignore
      const [day, month, year] = formData?.date?.split("-") || [];
      // Add 'key' field to each item (React uses this)
      const processed = unitData.map((item: any, index: number) => ({
        ...item,
        key: index + 1, // Or use item.lesson_plan_id if it's guaranteed unique,
        day: day,
        month: month,
        year: year,
      }));
      setTrainerDocFiles(processed || []); // Uncomment & adjust based on actual API response
    } catch (error) {
      console.error("Error fetching attendance:", error);
    } finally {
      // setTimeout(() => setIsLoading(false), 1000);
      if (firstTimeRender == 1) {
        setTimeout(() => setIsLoading(false), 2000);
        setFirstTimeRender(0);
        // console.log("in --- first time ")
      } else {
        setTimeout(() => setIsLoading(false), 600);
        // console.log("in --- else time ")
      }
    }
  };

  useEffect(() => {
    if (documentTabContent && Object.keys(documentTabContent)?.length > 0) {
      getTrainerDocs();
    }
  }, [documentTabContent, activeTab]);

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    tab: string,
  ) => {
    const files = event.target.files;
    console.log(files);
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      setUploadedFiles((prev) => {
        const newUploadedFiles = {
          ...prev,
          [tab]: [...(prev[tab] || []), ...fileArray],
        };
        return newUploadedFiles;
      });
    }
  };

  // const handleSave = async () => {
  //   const nonEmptyFiles = Object.keys(uploadedFiles).reduce((acc: any, tab) => {
  //     if (uploadedFiles[tab] && uploadedFiles[tab].length > 0) {
  //       acc[tab] = uploadedFiles[tab];
  //     }
  //     return acc;
  //   }, {});

  //   if (
  //     documentTabContent?.document_name === "Photographs per days of training"
  //   ) {
  //     const photoUploaded = await handleUploadPhotos();

  //     // if (!photoUploaded) {
  //     //   return;
  //     // }
  //   }

  //   // Save current uploaded files to localStorage if they are non-empty
  //   if (Object.keys(nonEmptyFiles).length > 0) {
  //     localStorage.setItem("uploadedFiles", JSON.stringify(nonEmptyFiles));
  //   }

  //   // Mark the active tab as completed
  //   const newCompletedTabs = { ...completedTabs, [activeTab]: true };
  //   setCompletedTabs(newCompletedTabs);

  //   // Save completed tabs to localStorage
  //   localStorage.setItem("completedTabs", JSON.stringify(newCompletedTabs));
  //   handleUploadPhotos();
  //   SubmitData();
  // };

  const handleSave = async () => {
    try {
      setIsSubmitting(true);

      // First upload photographs if this is photograph tab

      // Save normal uploaded documents
      const nonEmptyFiles = Object.keys(uploadedFiles).reduce(
        (acc: any, tab) => {
          if (uploadedFiles[tab]?.length > 0) {
            acc[tab] = uploadedFiles[tab];
          }

          return acc;
        },
        {},
      );

      if (Object.keys(nonEmptyFiles).length > 0) {
        localStorage.setItem("uploadedFiles", JSON.stringify(nonEmptyFiles));
      }

      // Save current tab
      const newCompletedTabs = {
        ...completedTabs,
        [activeTab]: true,
      };

      setCompletedTabs(newCompletedTabs);

      localStorage.setItem("completedTabs", JSON.stringify(newCompletedTabs));

      // Submit document only if there are normal uploaded files
      if (uploadedFiles[activeTab]?.length > 0) {
        await SubmitData();
      }

      // Refresh data
      await getTrainerDocs();
      await getDocuments();
    } catch (error) {
      console.error("Save failed:", error);
      toast.error("Failed to save.");
    } finally {
      setIsSubmitting(false);
    }
  };
  const SubmitData = async () => {
    const submitData = {
      school_code: formData?.school_code || "",
      employee_id: formData?.employee_id || "",
      form_seq_id: documentTabContent?.form_seq_id,
      upload_file_path: uploadedFiles[activeTab] || "",
    };

    if (submitData?.upload_file_path?.length == 0) {
      toast.error("Please upload file");
    }

    const formDataSubmit = new FormData();
    Object.entries(submitData)?.forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value?.forEach((item, index) => {
          formDataSubmit.append(`${key}`, item);
          // formDataSubmit.append(`${key}[${index}]`, item);
        });
      } else {
        formDataSubmit.append(key, value);
      }
    });

    try {
      setIsSubmitting(true);
      const resp = await axiosInstance.post(
        webserviceUrl.upload_student_documents,
        formDataSubmit,
      );
      // console.log("submission data", resp);
      const unitData = resp?.data?.data || [];
      //@ts-ignore
      const [day, month, year] = formData?.date?.split("-") || [];
      // Add 'key' field to each item (React uses this)
      const processed = unitData.map((item: any, index: number) => ({
        ...item,
        key: index + 1, // Or use item.lesson_plan_id if it's guaranteed unique,
        day: day,
        month: month,
        year: year,
      }));
      // console.log(resp?.data?.success)
      if (resp?.data?.success) {
        setDocumentList(processed || []); // Uncomment & adjust based on actual API response
        toast.success(resp?.data?.message);
        setUploadedFiles({});
        getTrainerDocs();
        getDocuments();
      } else {
        console.error(resp?.data?.message);
        toast.error(resp?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching attendance:", error);
    } finally {
      setTimeout(() => setIsSubmitting(false), 500);
    }
  };

  const handleFinalSubmit = async () => {
    const payload = {
      school_code: formData?.school_code,
      trainer_id: formData?.employee_id,
      level: course?.level,
      combination: course?.combination_code,
      class: course?.class,
      section: course?.section,
      // status: ,
    };
    try {
      setIsSubmitting(true);
      const resp = await axiosInstance.post(
        webserviceUrl?.final_submit_student_documents,
        payload,
      );

      const unitData = resp?.data?.data || [];
      //@ts-ignore
      if (resp?.data?.success) {
        toast.success(resp?.data?.message);
        setMergedPdfData(resp?.data?.merged_pdf);
        setActiveTab(documentList[0]?.document_name);
        getDocuments();
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Error fetching attendance:", error);
    }
  };

  // ------- state file delete
  const handleFileDelete = (tab: string, indexToDelete: number) => {
    // console.log(tab, indexToDelete)
    setUploadedFiles((prev) => ({
      ...prev,
      [tab]: prev[tab].filter((_, index) => index !== indexToDelete),
    }));
  };

  // ------ file delete from db
  const handledeleteServerFile = async (Id: string) => {
    try {
      const resp = await axiosInstance.post(
        webserviceUrl.delete_trainer_submission,
        {
          school_code: school_code || "",
          form_upload_id: Id || "",
        },
      );
      if (resp?.data?.success) {
        toast.success(resp?.data?.message || "File deleted successfully!");
        getTrainerDocs();
      }
    } catch (error) {
      console.error("Error fetching attendance:", error);
    }
  };

  // console.log(deleteTarget?.form_upload_id)
  const onConfirmDelete = () => {
    if (deleteTarget) {
      if (
        deleteTarget?.type === "local" &&
        deleteTarget?.tab !== undefined &&
        deleteTarget?.index !== undefined
      ) {
        handleFileDelete(deleteTarget.tab, deleteTarget.index);
      } else if (
        deleteTarget?.type === "server" &&
        deleteTarget?.form_upload_id
      ) {
        handledeleteServerFile(deleteTarget?.form_upload_id);
      }
    }
    setDeleteTarget(null);
  };

  // ----------- render files ---------------
  const RenderUploadedFiles: React.FC<RenderUploadedFilesProps> = ({
    files,
    type,
  }) => {
    // const files = uploadedFiles[tab] || [];
    const allFiles: any = files || [];

    if (allFiles?.length === 0) return null;
    return (
      <div className="table-responsive mt-3">
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th style={{ width: "5%" }}>SNo</th>
              <th>File Name</th>
              <th style={{ width: "10%" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {allFiles?.map((file: any, index: number) => {
              const fileName =
                type === "local"
                  ? file?.name
                  : file?.upload_file_path?.split("/").pop() || "-";
              const fileId =
                type === "local" ? String(index) : file?.form_upload_id;

              return (
                <tr key={`${file?.form_upload_id}-${file?.form_seq_id}`}>
                  <td>{index + 1}</td>
                  <td>{fileName}</td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        // console.log(file?.upload_file_path);
                        if (type === "local") {
                          window.open(URL.createObjectURL(file), "_blank");
                        } else {
                          window.open(file?.upload_file_path, "_blank");
                        }
                      }}
                      title="View File"
                    >
                      <i className="ti ti-eye" />
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_modal"
                      disabled={isSubmitting}
                      onClick={() => {
                        setDeleteTarget({
                          type,
                          tab: activeTab,
                          index,
                          form_upload_id: file?.form_upload_id,
                        });
                      }}
                      title="Delete File"
                    >
                      <i className="ti ti-trash" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const handleNext = () => {
    const currentIndex = documentTabContent?.seq;
    if (currentIndex < documentList.length) {
      const prevItem: any = documentList?.find(
        (item: any) => item?.seq === currentIndex + 1,
      );
      if (prevItem) {
        let nextTab = prevItem?.document_name;
        setActiveTab(nextTab);
        tabRefs.current[nextTab]?.scrollIntoView({
          behavior: "smooth",
          inline: "center",
        });
      }
    }
  };
  function getYouTubeId(url: string): string {
    const match = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/,
    );
    return match ? match[1] : "";
  }

  const handlePrev = () => {
    const currentIndex = documentTabContent?.seq; //index acc. to documentList "0" based index
    if (currentIndex > 0) {
      const prevItem: any = documentList?.find(
        (item: any) => item?.seq === currentIndex - 1,
      );
      if (prevItem) {
        const prevTab = prevItem?.document_name;
        setActiveTab(prevTab);
        tabRefs.current[prevTab]?.scrollIntoView({
          behavior: "smooth",
          inline: "center",
        });
      }
    }
  };

  // console.log(trainerDocFiles)
  // console.log(isConfirmDelete)

  if (pageLoading) {
    return (
      <div className="page-wrapper">
        <LoadingGreen />
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <DeleteModal handleDelete={onConfirmDelete} />
      <style>{`
  #daySelect option {
    padding: 10px 12px;
    font-weight: 500;
  }
  #daySelect:focus {
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
    border-color: #0d6efd;
  }
  .yt-upload-section {
  margin: 16px 0;
  max-width: 480px;
}

.yt-upload-label {
  display: block;
  font-size: 12.5px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.yt-upload-row {
  display: flex;
  gap: 8px;
}

.yt-upload-input {
  flex: 1 1 auto;
  min-width: 0;
  border: 1px solid #e6e3da;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13.5px;
}

.yt-upload-input:focus {
  outline: none;
  border-color: #16a34a;
  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.12);
}

.yt-upload-btn {
  flex-shrink: 0;
  background: #16a34a;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
}

.yt-upload-btn:disabled {
  background: #d1d5db;
  cursor: not-allowed;
}

.yt-preview-card {
  position: relative;
  margin-top: 12px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #eee;
}

.yt-thumb {
  width: 100%;
  display: block;
  aspect-ratio: 16 / 9;
  object-fit: cover;
}

.yt-play-badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.yt-remove-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  cursor: pointer;
  font-size: 13px;
}

.yt-upload-error {
  margin-top: 8px;
  font-size: 12.5px;
  color: #dc2626;
}
`}</style>
      <div className="content">
        {/* Breadcrumb */}
        <div>
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Submission</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/employee-dashboard">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Teacher</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Submission
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="mb-2">
            {/* <div className="dropdown">
              <button
                type="button"
                className="btn btn-outline-light bg-white border d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                disabled={cohortLoading || cohortOptions.length === 0}
                style={{ minWidth: "220px", justifyContent: "space-between" }}
              >
                <div className="d-flex align-items-center">
                  <i className="ti ti-users me-2 text-primary" />
                  <span className="me-1 text-truncate">
                    {cohortLoading
                      ? "Loading cohorts..."
                      : selectedCohort || "Select cohort"}
                  </span>
                </div>
                <i className="ti ti-chevron-down ms-1" />
              </button>
              <ul className="dropdown-menu dropdown-menu-end p-2">
                {cohortOptions.map((cohort) => (
                  <li key={cohort}>
                    <button
                      type="button"
                      className={`dropdown-item rounded d-flex align-items-center justify-content-between${
                        cohort?.course_name === selectedCohort ? " active" : ""
                      }`}
                      onClick={() => {
                        setSelectedCohort(cohort?.course_name);
                        setcohort(cohort);
                      }}
                    >
                      {cohort?.course_name}
                      {cohort?.course_name === selectedCohort && (
                        <i className="ti ti-check" />
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            </div> */}
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="card mb-3">
          <div className="card-body p-3">
            <div
              className="w-100"
              style={{ overflowX: "auto", whiteSpace: "nowrap" }}
            >
              <ul
                className="nav nav-tabs justify-content-start flex-nowrap overflow-x-auto "
                style={{ minWidth: "max-content", whiteSpace: "nowrap" }}
              >
                {/* {tabSteps.map((tab) => ( */}
                {documentList?.map((tab: any) => {
                  // // console.log(tab.document_name)
                  return (
                    <li
                      className="nav-item d-inline-block"
                      key={tab?.document_name}
                    >
                      <button
                        ref={(el) => (tabRefs.current[tab?.document_name] = el)}
                        className="nav-link px-3 py-2 rounded mb-1"
                        onClick={(e) => {
                          setActiveTab(tab?.document_name);
                          e.currentTarget.scrollIntoView({
                            behavior: "smooth",
                            inline: "center",
                            block: "nearest",
                          });
                        }}
                        style={{
                          backgroundColor:
                            activeTab === tab?.document_name
                              ? "#16a34a"
                              : tab?.info_saved == 1
                                ? "green"
                                : "transparent",
                          color:
                            activeTab === tab?.document_name ||
                            tab?.info_saved == 1
                              ? "white"
                              : "black",
                          border: "1px solid",
                          borderColor:
                            activeTab === tab?.document_name
                              ? "#16a34a"
                              : "#ddd",
                        }}
                        // disabled
                      >
                        {tab?.document_name}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            {/* <h2>firsttimerender: {firstTimeRender}</h2> */}
            <h4 className="mb-3">{documentTabContent?.document_name}</h4>
            <p>
              {documentTabContent?.document_name == "Relieving Letter"
                ? ""
                : documentTabContent?.display_message}
            </p>
            {documentTabContent?.document_name ===
              "Photographs per days of training" && (
              <div
                className="mb-4"
                style={{ maxWidth: "220px" }}
                ref={dropdownRef}
              >
                {/* ...your existing day-selector code stays exactly as-is... */}
              </div>
            )}

            {documentTabContent?.document_name ===
              "Photographs per days of training" && (
              <div className="mb-4">
                <div className="mb-4" style={{ maxWidth: "220px" }}>
                  <label className="form-label fw-semibold text-secondary">
                    <i className="ti ti-calendar-event me-1"></i>
                    Select Date
                  </label>

                  <div className="input-group shadow-sm">
                    <span className="input-group-text bg-primary text-white border-0">
                      <i className="ti ti-calendar"></i>
                    </span>

                    <input
                      type="date"
                      className="form-control border-0"
                      value={selectedDay || ""}
                      onChange={(e: any) => setSelectedDay(e.target.value)}
                      style={{
                        height: "38px",
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
                <label className="form-label fw-semibold text-secondary">
                  <i className="ti ti-photo me-1"></i>
                  Upload Photographs
                  {selectedDay && (
                    <span className="text-muted fw-normal ms-1">
                      ({selectedDay})
                    </span>
                  )}
                </label>
              </div>
            )}

            {documentTabContent?.document_name == "Program Detail" && (
              <>
                <div className="yt-upload-section">
                  <label className="yt-upload-label">
                    Program video (YouTube link)
                  </label>

                  <div className="yt-upload-row">
                    <input
                      type="url"
                      className="yt-upload-input"
                      placeholder="Paste YouTube link here..."
                      value={youtubeLink}
                      onChange={(e: any) => setYoutubeLink(e.target.value)}
                    />
                    <button
                      type="button"
                      className="yt-upload-btn"
                      disabled={!youtubeLink.trim()}
                      onClick={() => handleSaveYoutubeLink(youtubeLink)}
                    >
                      Save
                    </button>
                  </div>

                  {youtubeLink && getYouTubeId(youtubeLink) && (
                    <div className="yt-preview-card">
                      <img
                        src={`https://img.youtube.com/vi/${getYouTubeId(youtubeLink)}/hqdefault.jpg`}
                        alt="Video preview"
                        className="yt-thumb"
                      />
                      <div className="yt-play-badge">▶</div>
                      <button
                        type="button"
                        className="yt-remove-btn"
                        // onClick={() => setYoutubeLink("")}
                        onClick={() => {}}
                      >
                        ✕
                      </button>
                    </div>
                  )}

                  {youtubeLink && !getYouTubeId(youtubeLink) && (
                    <p className="yt-upload-error">
                      That doesn't look like a valid YouTube link.
                    </p>
                  )}
                </div>
              </>
            )}
            {/* Hidden File Input */}
            {/* <input
              type="file"
              accept=".pdf"
              // accept={`.${documentTabContent?.allowed_file_types}`}
              id="fileUploadInput"
              multiple
              onChange={(e) => handleFileChange(e, activeTab)}
              className="d-none"
            /> */}

            <input
              ref={fileInputRef}
              type="file"
              accept={
                documentTabContent?.document_name ===
                "Photographs per days of training"
                  ? "image/*"
                  : ".pdf"
              }
              id="fileUploadInput"
              multiple
              onChange={(e) => {
                if (
                  documentTabContent?.document_name ===
                  "Photographs per days of training"
                ) {
                  handleFilesSelected(e);
                } else {
                  handleFileChange(e, activeTab);
                }
              }}
              className="d-none"
            />
            {/* Add File Button */}
            {documentTabContent?.document_name ===
            "Photographs per days of training" ? (
              selectedDay && (
                <button
                  className="btn btn-outline-primary mb-3"
                  onClick={() =>
                    document.getElementById("fileUploadInput")?.click()
                  }
                >
                  <i className="ti ti-plus me-1"></i> Upload File
                </button>
              )
            ) : documentTabContent?.document_name == "Relieving Letter" ? (
              ""
            ) : (
              <button
                className="btn btn-outline-primary mb-3"
                onClick={() =>
                  document.getElementById("fileUploadInput")?.click()
                }
              >
                <i className="ti ti-plus me-1"></i> Upload File
              </button>
            )}

            {/* Selected photograph previews */}
            {documentTabContent?.document_name ===
              "Photographs per days of training" &&
              selectedFiles.length > 0 && (
                <div className="mt-4">
                  <h4 className="mb-3">Selected Photos:</h4>

                  <div className="row g-3">
                    {selectedFiles.map((file, index) => (
                      <div
                        className="col-6 col-md-4 col-lg-3"
                        key={`${file.name}-${index}`}
                      >
                        <div
                          className="card h-100"
                          style={{
                            overflow: "hidden",
                            borderRadius: "10px",
                          }}
                        >
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              aspectRatio: "4 / 3",
                              background: "#f5f5f5",
                            }}
                          >
                            <img
                              src={URL.createObjectURL(file)}
                              alt={file.name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />

                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              style={{
                                position: "absolute",
                                top: "8px",
                                right: "8px",
                                borderRadius: "50%",
                                width: "30px",
                                height: "30px",
                                padding: 0,
                              }}
                              onClick={() => removeSelectedFile(index)}
                            >
                              <i className="ti ti-trash" />
                            </button>
                          </div>

                          <div className="card-body p-2">
                            <div
                              className="text-truncate"
                              title={file.name}
                              style={{ fontSize: "12px" }}
                            >
                              {file.name}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

            {/* Render Uploaded Files Table */}
            {isLoading ? (
              <Loading />
            ) : (
              trainerDocFiles?.length > 0 && (
                <RenderUploadedFiles files={trainerDocFiles} type="server" />
              )
            )}

            {uploadedFiles && Object.keys(uploadedFiles)?.length > 0 && (
              <>
                <h4 className="mt-4">Newly Added:</h4>
                <RenderUploadedFiles
                  files={uploadedFiles[activeTab] || []}
                  type="local"
                />
              </>
            )}

            <div className=" mt-4 " style={{ borderTop: "2px solid #ddd" }}>
              <div className="d-flex justify-content-between mt-2">
                <button
                  className="btn btn-secondary"
                  onClick={handlePrev}
                  disabled={documentTabContent?.seq == 1}
                >
                  Prev
                </button>
                <div>
                  <button
                    className="btn btn-outline-primary me-2"
                    disabled={isSubmitting || isLoading}
                    onClick={() => {
                      console.log(documentTabContent?.document_name);

                      if (
                        documentTabContent?.document_name ==
                        "Photographs per days of training"
                      ) {
                        handleUploadPhotos();

                        // if (!photoUploaded) {
                        //   return;
                        // }
                      } else {
                        handleSave();
                      }
                    }}
                  >
                    {isSubmitting ? (
                      <>
                        {" "}
                        <span
                          className="spinner-border spinner-border-sm  me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>{" "}
                        Saving
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                  {isLastTab ? (
                    <button
                      className="btn btn-primary border-0"
                      type="button"
                      disabled={isSubmitting || isNextDisabled}
                      onClick={handleFinalSubmit}
                      style={{ backgroundColor: `green` }}
                    >
                      {isSubmitting ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm  me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Submitting...
                        </>
                      ) : (
                        <>Submit</>
                      )}
                    </button>
                  ) : (
                    <button
                      className={`btn btn-primary`}
                      onClick={handleNext}
                      // disabled={isNextDisabled}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {mergedPdfData && (
          <div className="card ">
            <div className="card-body py-4">
              <h5>Merged PDF</h5>
              <p className="pt-2 mb-0">Download your merged PDF here...</p>
              <Link
                to={mergedPdfData}
                target="_blank"
                className="btn btn-primary mt-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-download me-2"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                </svg>
                Download PDF
              </Link>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
    </div>
  );
};

export default Submissionbatch;

// const tabSteps = [
//   "Student Data Sheet",
//   "Attendance Sheet Handwritten",
//   "Attendance Sheet Printed",
//   "Assessment Marksheet",
//   "Sample Assessments",
//   "Trainer Details",
//   "Trainer CV",
//   "Session Deliver Plan",
//   "Learning Outcomes",
//   "Trainer Feedback Form",
//   "Letter for Appreciation",
//   "Student Certificates",
//   "Photographs",
// ];

// const tabContent: any = {
//   "Student Data Sheet": {
//     label: "Student Data Sheet",
//     description:
//       "Upload the student data sheet (Excel, PDF) with all the student details for the batch. Make sure the data sheet is correct and complete.",
//   },
//   "Attendance Sheet Handwritten": {
//     label: "Attendance Sheet Handwritten",
//     description:
//       "Upload the handwritten attendance sheet for your students. It should clearly list all the students present in the session.",
//   },
//   "Attendance Sheet Printed": {
//     label: "Attendance Sheet Printed",
//     description:
//       "Upload the printed version of the attendance sheet. Ensure it has signatures and all necessary details.",
//   },
//   "Assessment Marksheet": {
//     label: "Assessment Marksheet",
//     description:
//       "Upload the assessment marksheet, including student scores for the assessment conducted.",
//   },
//   "Sample Assessments": {
//     label: "Sample Assessments",
//     description:
//       "Upload samples of assessments that were given during the session, either in PDF or image format.",
//   },
//   "Trainer Details": {
//     label: "Trainer Details",
//     description:
//       "Upload the trainer's details, including qualifications, experience, and any necessary certifications.",
//   },
//   "Trainer CV": {
//     label: "Trainer CV",
//     description: "Upload the trainer's curriculum vitae (CV) in PDF format.",
//   },
//   "Session Deliver Plan": {
//     label: "Session Deliver Plan",
//     description:
//       "Upload the plan for the session delivery, including the schedule, topics covered, and resources used.",
//   },
//   "Learning Outcomes": {
//     label: "Learning Outcomes",
//     description:
//       "Upload a document stating the learning outcomes of the training or session.",
//   },
//   "Trainer Feedback Form": {
//     label: "Trainer Feedback Form",
//     description:
//       "Upload the feedback forms filled out by the students for the trainer's performance.",
//   },
//   "Letter for Appreciation": {
//     label: "Letter for Appreciation",
//     description:
//       "Upload any letters of appreciation or recognition received by the trainer or institution for the session.",
//   },
//   "Student Certificates": {
//     label: "Student Certificates",
//     description:
//       "Upload the certificates issued to students for successful completion of the session.",
//   },
//   Photographs: {
//     label: "Photographs",
//     description:
//       "Upload photographs of the training session, including any group photos, event photos, etc.",
//   },
// };

// const handlePrev = () => {
//   const currentIndex = tabSteps.indexOf(activeTab);
//   if (currentIndex > 0) {
//     setActiveTab(tabSteps[currentIndex - 1]);
//   }
// };
